import type { NegociacaoCustomFieldType } from '../types';

const dateFormatter = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const currencyFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

const numberFormatter = new Intl.NumberFormat('pt-BR');

export function formatCustomFieldValue(value: unknown, type: NegociacaoCustomFieldType): string {
  if (value === null || value === undefined || value === '') return '—';

  switch (type) {
    case 'BOOLEAN':
      return value ? 'Sim' : 'Não';
    case 'NUMBER':
      return formatNumber(value);
    case 'FINANCEIRO':
      return formatCurrency(value);
    case 'DATE':
      return formatDate(value);
    case 'STRING':
    case 'ENUM':
    default:
      return formatString(value);
  }
}

function formatNumber(value: unknown): string {
  if (typeof value === 'number') return numberFormatter.format(value);
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return String(value);
  return numberFormatter.format(parsed);
}

function formatCurrency(value: unknown): string {
  if (typeof value === 'number') return currencyFormatter.format(value);
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return String(value);
  return currencyFormatter.format(parsed);
}

function formatDate(value: unknown): string {
  if (typeof value !== 'string') return String(value);
  const trimmed = value.trim();
  const isoMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(trimmed);
  if (isoMatch) {
    return `${isoMatch[3]}/${isoMatch[2]}/${isoMatch[1]}`;
  }
  const date = new Date(trimmed);
  if (Number.isNaN(date.getTime())) return trimmed;
  return dateFormatter.format(date);
}

function formatString(value: unknown): string {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}
